import type { Suggest } from '~/types/search'

/**
 * Pages of the site a search should lead to although they are not in the search index (16/10/2026, Julien:
 * "comment s'inscrire" found news about game betas, never the sign-up page). A shortcut only shows when the search
 * is only about it: "comment s'inscrire", "créer un compte", "inscription wap"; not "inscription bêta marathon".
 */
const SIGN_UP: Suggest = {
  id: 'shortcut-inscription',
  title: "S'inscrire sur We Are PlayStation",
  type: 'Page du site',
  route: '/inscription',
}

// words that can go with the question: "comment je peux m'inscrire", "comment faire pour créer un compte"
const FILLERS = new Set([
  'comment', 'comme', 'faire', 'fait', 'fais', 'je', 'j', 'me', 'm', 's', 'se', 't', 'te', 'on', 'peut', 'peux',
  'pouvoir', 'veux', 'voudrais', 'vouloir', 'pour', 'un', 'une', 'mon', 'ma', 'le', 'la', 'les', 'l', 'de', 'du', 'des',
  'd', 'a', 'au', 'sur', 'ou', 'quoi', 'svp', 'stp', 'how', 'to', 'en', 'up',
])
// words that may come with the subject of the search
const CONTEXT = new Set([
  'wap', 'we', 'are', 'playstation', 'site', 'compte', 'gratuit', 'gratuitement', 'nouveau', 'nouvel', 'creer', 'cree',
  'crees', 'creation', 'ouvrir', 'ouvre', 'avoir',
])

// the sign-up itself, typos included: inscription, inscrire, incrire, inscrir, enregistrer, register, sign up
const isSignUpWord = (w: string) => /^(i(n)?s?cr?i|enregistr|register|signup|sign)/.test(w)

const words = (q: string) =>
  q
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[’'`.,!?;:-]/g, ' ')
    .split(/\s+/)
    .filter(Boolean)

/** the shortcut a typed search should show first, if any */
export const searchShortcut = (q: string): Suggest | null => {
  const meaningful = words(q).filter((w) => !FILLERS.has(w))
  if (!meaningful.length || meaningful.some((w) => !isSignUpWord(w) && !CONTEXT.has(w))) return null

  const signUp = meaningful.some(isSignUpWord)
  // "créer un compte", "ouvrir un compte": the account and a word that creates it
  const newAccount = meaningful.includes('compte') && meaningful.some((w) => /^(cree|creer|crees|creation|ouvr|nouve)/.test(w))

  return signUp || newAccount ? SIGN_UP : null
}
